{
  "en": {
    "activerecord": {
      "attributes": {
        "admin_user": {
          "email": "Email",
          "full_name": "Full name",
          "identification_document_number": "RUT"
        },
        "company/bussiness_area": {
          "name": "Name"
        },
        "user": {
          "email": "Email",
          "identification_document_number": "RUT",
          "login": "Email o RUT"
        }
      },
      "enums": {
        "personal/information": {
          "genders": {
            "female": "Female",
            "male": "Male"
          }
        },
        "personal/laboral_requirement": {
          "preferred_labor_days": {
            "monday_friday": "Lunes a Viernes",
            "monday_sunday": "Lunes a Domingo",
            "weekends": "Fines de Semana"
          },
          "preferred_schedules": {
            "full_time": "Tiempo Completo",
            "half_time": "Media Jornada",
            "part_time": "PartTime"
          },
          "preferred_turn": {
            "day_time": "Diurno",
            "rotative": "Rotativo",
            "vespertine": "Vespertino"
          }
        }
      },
      "errors": {
        "format": "%{attribute} %{message}",
        "messages": {
          "accepted": "must be accepted",
          "blank": "can't be blank",
          "confirmation": "doesn't match",
          "empty": "can't be empty",
          "equal_to": "must be equal to %{count}",
          "even": "must be even",
          "exclusion": "its reserved",
          "greater_than": "must be greater than %{count}",
          "greater_than_or_equal_to": "must greater or equal to %{count}",
          "inclusion": "is not included on the list",
          "invalid": "it's invalid",
          "less_than": "must be lesset than %{count}",
          "less_than_or_equal_to": "must be lesser than or equal to %{count}",
          "not_a_number": "it's not a number",
          "not_an_integer": "must be integer",
          "odd": "must be odd",
          "other_than": "it must be different from %{count}",
          "present": "must be blank",
          "record_invalid": "the validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists",
            "many": "The record can not be deleted because there are dependants %{record}",
            "one": "The record can not be deleted because there is a dependant %{record}"
          },
          "taken": "already in use",
          "too_long": "it's too large (%{count} max chars)",
          "too_short": "it's too short (%{count} min chars)",
          "valid": "must be valid",
          "wrong_length": "does not have the correct length (%{count} exact chars)"
        },
        "models": {
          "admin_user": {
            "attributes": {
              "email": {
                "taken": "Email has already been taken"
              },
              "identification_document_number": {
                "blank": "RUT can't be blank",
                "invalid": "RUT is invalid",
                "taken": "RUT has already been taken"
              }
            }
          },
          "user": {
            "attributes": {
              "email": {
                "blank": "Must entry a Email",
                "taken": "This Email is already registered"
              },
              "login": {
                "blank": "Must entry Email or RUT"
              },
              "password": {
                "blank": "Must entry a password"
              }
            }
          }
        }
      },
      "models": {
        "admin_user": {
          "one": "Admin user",
          "other": "Admin users"
        },
        "company/bussiness_area": {
          "one": "Bussiness Area",
          "other": "Bussiness Areas"
        },
        "user": {
          "one": "User",
          "other": "Users"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "subject": "Email Changed"
        },
        "password_change": {
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirm link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again"
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "unlocks": {
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "hello": "Hello world",
    "helpers": {
      "page_entries_info": {
        "entry": {
          "one": "entry",
          "other": "entries",
          "zero": "entries"
        },
        "more_pages": {
          "display_entries": "Displaying %{entry_name} <b>%{first}&nbsp;-&nbsp;%{last}</b> of <b>%{total}</b> in total"
        },
        "one_page": {
          "display_entries": {
            "one": "Displaying <b>1</b> %{entry_name}",
            "other": "Displaying <b>all %{count}</b> %{entry_name}",
            "zero": "No %{entry_name} found"
          }
        }
      },
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "views": {
      "pagination": {
        "first": "&laquo; First",
        "last": "Last &raquo;",
        "next": "Next &rsaquo;",
        "previous": "&lsaquo; Prev",
        "truncate": "&hellip;"
      }
    }
  },
  "es": {
    "activerecord": {
      "aasm_state": {
        "company/purchase": {
          "canceled": "Pago Cancelado",
          "expited": "Expirado",
          "paid_out": "Pagado",
          "pending_payment": "Pago Pendiente"
        }
      },
      "attributes": {
        "admin_user": {
          "email": "Email",
          "full_name": "Nombre completo",
          "identification_document_number": "RUT"
        },
        "company/bussiness_area": {
          "name": "Nombre"
        },
        "personal/education": {
          "education_degree": "Tipo",
          "graduated_at": "Fecha de Egreso"
        },
        "personal/information": {
          "address": "Dirección",
          "avatar": "Foto de Perfil",
          "cellphone": "Celular",
          "disability_institution": "Nombre de la Institución",
          "first_name": "Nombres",
          "gender": "Género",
          "has_associated_institution": "Está asociado a una Institución?",
          "has_disability_credential": "Tiene Credencial de Discapacidad?",
          "has_drivers_license": "Tiene licencia de conducir?",
          "has_invalidity_pension": "Cuenta con Pensión de Invalidez?",
          "landline": "Teléfono fijo",
          "last_email": "Email secundario",
          "last_name": "Apellidos",
          "territory_commune": "Comuna",
          "territory_country": "País",
          "territory_nationality": "Nacionalidad",
          "territory_region": "Región"
        },
        "personal/laboral_requirement": {
          "desired_communes": "Comunas de Interés",
          "dress_code": "Código de Vestimenta",
          "expected_salary": "Expectativas de sueldo líquido",
          "laboral_areas": "Áreas Laborales",
          "preferred_labor_day": "Horario laboral de preferencia",
          "preferred_schedule": "Jornada laboral de preferencia",
          "preferred_turn": "Extensión de la jornada"
        },
        "personal_information_attributes": {
          "cellphone": "Celular"
        },
        "user": {
          "confirmation_sent_at": "Confirmación enviada a",
          "confirmation_token": "Código de confirmación",
          "confirmed_at": "Confirmado en",
          "created_at": "Creado en",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Fecha del ingreso actual",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Email",
          "encrypted_password": "Contraseña cifrada",
          "failed_attempts": "Intentos fallidos",
          "identification_document_number": "RUT",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último inicio",
          "locked_at": "Fecha de bloqueo",
          "login": "Email o RUT",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "personal_information": {
            "cellphone": "Celular"
          },
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de código para contraseña",
          "reset_password_token": "Código para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "terms_and_conditions": "Términos y Condiciones",
          "unconfirmed_email": "Email no confirmado",
          "unlock_token": "Código de desbloqueo",
          "updated_at": "Actualizado en"
        }
      },
      "enums": {
        "course": {
          "contract_types": {
            "fixed_term": "Plazo Fijo",
            "indefinite_term": "Plazo Indefinido",
            "practical_term": "Práctica"
          }
        },
        "minisite/publication": {
          "dress_code": {
            "false": "No",
            "indifferent": "Indiferente",
            "true": "Si"
          },
          "education_levels": {
            "higher_complete": "Educación Superior completa",
            "higher_incomplete": "Educación Superior incompleta",
            "primary_complete": "Educación básica completa",
            "primary_incomplete": "Educación básica incompleta",
            "secondary_complete": "Educación media completa",
            "secondary_incomplete": "Educación media incompleta",
            "special_education": "Educación Especial"
          },
          "fixed_term_reason": {
            "license": "Licencia",
            "other": "Otro",
            "prenatal": "Pre-Natal"
          },
          "preferred_labor_days": {
            "monday_friday": "Lunes a Viernes",
            "monday_sunday": "Lunes a Domingo",
            "weekends": "Fines de Semana"
          },
          "preferred_schedules": {
            "full_time": "Tiempo Completo",
            "half_time": "Media Jornada",
            "part_time": "PartTime"
          },
          "preferred_turns": {
            "day_time": "Diurno",
            "rotative": "Rotativo",
            "vespertine": "Vespertino"
          },
          "replacement_reason": {
            "disengagement": "Desvinculación",
            "reasignation": "Renuncia",
            "relocation": "Movilidad interna"
          },
          "request_reason": {
            "new_vacancy": "Nueva Vacante",
            "other": "Otros",
            "practical": "Práctico",
            "replacement": "Reemplazo"
          },
          "requesting_company": {
            "empresa_1": "Empresa interna 1",
            "empresa_2": "Empresa interna 2",
            "empresa_3": "Empresa interna 3",
            "empresa_4": "Empresa interna 4"
          },
          "search_type": {
            "external": "Externa",
            "internal": "Interna",
            "mixed": "Mixta"
          }
        },
        "personal/contact_information": {
          "how_contact_mes": {
            "me": "A Mi",
            "other": "Otra persona"
          },
          "relationships": {
            "brother_or_sister": "Hermano(a)",
            "cousin": "Primo(a)",
            "father": "Padre",
            "friend": "Amigo(a)",
            "mother": "Madre",
            "uncle_or_aunt": "Tio(a)"
          }
        },
        "personal/information": {
          "drivers_licenses": {
            "a1": "Clase A1",
            "a2": "Clase A2",
            "a3": "Clase A3",
            "a4": "Clase A4",
            "a5": "Clase A5",
            "b": "Clase B",
            "c": "Clase C",
            "d": "Clase D",
            "e": "Clase E",
            "f": "Clase F",
            "not": "No Tengo"
          },
          "education_levels": {
            "higher_complete": "Educación Superior completa",
            "higher_incomplete": "Educación Superior incompleta",
            "primary_complete": "Educación básica completa",
            "primary_incomplete": "Educación básica incompleta",
            "secondary_complete": "Educación media completa",
            "secondary_incomplete": "Educación media incompleta",
            "special_education": "Educación Especial"
          },
          "genders": {
            "female": "Femenino",
            "fluid_gender": "Fluido",
            "male": "Masculino",
            "non_binary": "No Binario",
            "other": "Otro",
            "prefer_not_say": "Prefiero no decirlo"
          }
        },
        "personal/laboral_requirement": {
          "dress_code": {
            "indifferent": "Código de Vestimenta Formal Indiferente",
            "no": "No Posee Código de Vestimenta Formal",
            "yes": "Con Código de Vestimenta Formal"
          },
          "preferred_labor_days": {
            "monday_friday": "Lunes a Viernes",
            "monday_sunday": "Lunes a Domingo",
            "weekends": "Fines de Semana"
          },
          "preferred_schedules": {
            "full_time": "Tiempo Completo",
            "half_time": "Media Jornada",
            "part_time": "PartTime",
            "remote_work": "Teletrabajo"
          },
          "preferred_turns": {
            "day_time": "Diurno",
            "rotative": "Rotativo",
            "vespertine": "Vespertino"
          }
        },
        "publication/base": {
          "dress_code": {
            "false": "No",
            "indifferent": "Indiferente",
            "true": "Si"
          },
          "education_levels": {
            "higher_complete": "Educación Superior completa",
            "higher_incomplete": "Educación Superior incompleta",
            "primary_complete": "Educación básica completa",
            "primary_incomplete": "Educación básica incompleta",
            "secondary_complete": "Educación media completa",
            "secondary_incomplete": "Educación media incompleta",
            "special_education": "Educación Especial"
          },
          "preferred_labor_days": {
            "monday_friday": "Lunes a Viernes",
            "monday_sunday": "Lunes a Domingo",
            "weekends": "Fines de Semana"
          },
          "preferred_schedules": {
            "full_time": "Tiempo Completo",
            "half_time": "Media Jornada",
            "part_time": "PartTime",
            "remote_work": "Teletrabajo"
          },
          "preferred_turns": {
            "day_time": "Diurno",
            "rotative": "Rotativo",
            "vespertine": "Vespertino"
          }
        }
      },
      "errors": {
        "format": "%{attribute} %{message}",
        "messages": {
          "accepted": "debe ser aceptado",
          "at_most_five": "no puede tener más de 5 comunas seleccionadas",
          "at_most_ten": "no puede tener más de 10 áreas seleccionadas",
          "blank": "no puede estar en blanco",
          "confirmation": "no coincide",
          "empty": "no puede estar vacío",
          "equal_to": "debe ser igual a %{count}",
          "even": "debe ser par",
          "exclusion": "está reservado",
          "greater_than": "debe ser mayor que %{count}",
          "greater_than_or_equal_to": "Debe ser mayor o igual a %{count}",
          "inclusion": "no está incluido en la lista",
          "invalid": "no es válido",
          "less_than": "debe ser menor que %{count}",
          "less_than_or_equal_to": "Debe ser menor o igual a %{count}",
          "missing_required_step": "No puedes avanzar porque falta completar un paso requerido: %{step}",
          "not_a_number": "No es un número",
          "not_an_integer": "debe ser un entero",
          "odd": "debe ser impar",
          "other_than": "debe ser distinto de %{count}",
          "present": "debe estar en blanco",
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          },
          "taken": "ya está en uso",
          "too_long": "es demasiado largo (%{count} caracteres máximo)",
          "too_short": "es demasiado corto (%{count} caracteres mínimo)",
          "valid": "debe ser válido",
          "wrong_length": "no tiene la longitud correcta (%{count} caracteres exactos)"
        },
        "models": {
          "admin_user": {
            "attributes": {
              "email": {
                "taken": "El correo ya está registrado"
              },
              "identification_document_number": {
                "blank": "Debes ingresar el RUT",
                "invalid": "Debes ingresar un RUT válido",
                "taken": "El RUT ya se encuentra registrado"
              }
            }
          },
          "company/central": {
            "attributes": {
              "avatar": {
                "content_type": "Solo se permite JPG, JPEG, PNG",
                "max_size_error": "No puede superar los 2mb"
              },
              "email": {
                "blank": "Debe ingresar un Email",
                "taken": "Este Email ya se encuentra registrado"
              },
              "identification_number": {
                "blank": "Este RUT ya se encuentra registrado",
                "invalid": "Debe ingresar un RUT válido"
              },
              "name": {
                "blank": "Debe ingresar el Nombre",
                "taken": "Ya existe una Empresa con este Nombre"
              },
              "territory_commune": {
                "blank": "Debe seleccioar una opción"
              }
            }
          },
          "company/employee": {
            "attributes": {
              "current_position": {
                "blank": "Debe ingresar el Cargo"
              }
            }
          },
          "company/purchase": {
            "attributes": {
              "product": {
                "trial_present": "Ya tienes un Prueba Gratis asignada!"
              }
            }
          },
          "course": {
            "attributes": {
              "contract_type": {
                "blank": "Debe seleccionar un Tipo de Contrato"
              },
              "job_description": {
                "blank": "Debe ingresar una Descripción del Cargo"
              },
              "laboral_area": {
                "blank": "Debe seleccionar una Opción"
              },
              "title": {
                "blank": "Debe ingresar un Título de publicación"
              }
            }
          },
          "document/descriptor": {
            "attributes": {
              "allowed_file_types": {
                "blank": "Debe selecionar al menos una extensión"
              },
              "name": {
                "blank": "Debe ingresar un Nombre"
              }
            }
          },
          "enrollment": {
            "attributes": {
              "missing_required_step": "No puedes avanzar porque falta completar un paso requerido: %{step}"
            },
            "postulation/base": {
              "attributes": {
                "enrollment": {
                  "missing_required_step": "No puedes avanzar porque falta completar un paso requerido: %{step}"
                }
              }
            }
          },
          "interview/appointment": {
            "attributes": {
              "address": {
                "blank": "Debe ingresar una Dirección"
              },
              "appointment_date": {
                "blank": "Debe una Fecha y Hora"
              },
              "manager_contact": {
                "blank": "Debe ingresar un Email y/o Teléfono"
              },
              "manager_name": {
                "blank": "Debe ingresar un Nombre"
              }
            }
          },
          "minisite/postulation": {
            "attributes": {
              "aasm_state": {
                "pending": "La postulación se encuentra pendiente",
                "rejected": "La postulación se encuentra rechazada"
              },
              "enrollment": {
                "course_closed": "El proceso se encuentra cerrado",
                "current_stage_pending": "Etapa Actual se encuentra pendiente",
                "current_stage_rejected": "Etapa Actual se encuentra rechazada",
                "finished_workflow": "Candidato finalizó el proceso",
                "has_study_and_laboral_experience": "Debes agregar al menos un estuido y una experiencia laboral en tu perfil"
              }
            }
          },
          "minisite/publication": {
            "attributes": {
              "address": {
                "blank": "Debe ingresar una Dirección"
              },
              "benefits": {
                "blank": "Debe ingresar el Detalle de Beneficios"
              },
              "buk_id": {
                "blank": "Debe ingresar un ID de Buk"
              },
              "desactivate_at": {
                "blank": "Debe selecionar una Fecha de Expiración",
                "date_after": "No puede superar los 30 días",
                "date_before": "No puede ser anterior a la fecha de hoy",
                "invalid_date": "No es una fecha valida, No debe superar 30 días"
              },
              "dress_code": {
                "blank": "Debe seleccionar Código de Vestimenta Laboral Formal"
              },
              "education_level": {
                "blank": "Debe seleccionar un Nivel Educacional"
              },
              "employee_replacement": {
                "blank": "Debe indicar a quién reemplaza"
              },
              "experience_years": {
                "blank": "Debe ingresar Años de Experiencia"
              },
              "fixed_term_reason": {
                "blank": "Debe indicar el Motivo del Plazo Fijo"
              },
              "head": {
                "blank": "Debe seleccionar una Jefatura Directa"
              },
              "location": {
                "blank": "Debe ingresar una Ubicación"
              },
              "management": {
                "blank": "Debe seleccionar División y Gerencia"
              },
              "position": {
                "blank": "Debe seleccionar un Cargo"
              },
              "position_family": {
                "blank": "Debe seleccionar una Familia del cargo"
              },
              "preferred_labor_day": {
                "blank": "Debe seleccionar una Extensión de la jornada"
              },
              "preferred_schedule": {
                "blank": "Debe seleccionar una Jornada Laboral"
              },
              "preferred_turn": {
                "blank": "Debe seleccionar un Horario y/o Turno"
              },
              "profile_position": {
                "blank": "Debe ingresar un Perfil del cargo"
              },
              "recruiter": {
                "blank": "Debe ingresar un Reclutador"
              },
              "replacement_reason": {
                "blank": "Debe indicar el Motivo del Reemplazo"
              },
              "request_reason": {
                "blank": "Debe seleccionar un Motivo de Solicitud"
              },
              "requesting_company": {
                "blank": "Debe seleccionar una Empresa que Solicita"
              },
              "requirements": {
                "blank": "Debe ingresar Requerimientos Mínimos"
              },
              "salary_offered": {
                "blank": "Debe ingresar un Sueldo Líquido"
              },
              "search_type": {
                "blank": "Debe seleccionar un tipo de Búsqueda"
              },
              "territory_commune": {
                "blank": "Debe seleccionar País, Región y Comuna"
              },
              "vacancy_requester": {
                "blank": "Debe ingresar Quien solicita la vacante"
              }
            }
          },
          "personal/contact_information": {
            "attributes": {
              "contact_email": {
                "blank": "Debe ingresar un Email"
              },
              "contact_name": {
                "blank": "Debe ingresar un Nombre"
              },
              "contact_phone_number": {
                "blank": "Debe ingresar un Teléfono"
              },
              "relationship": {
                "blank": "Debe seleccionar un Parentesco"
              }
            }
          },
          "personal/education": {
            "attributes": {
              "career_name": {
                "blank": "Debe agregar un Nombre"
              },
              "education_career": {
                "blank": "Debe seleccionar una Carrera",
                "taken": "Ya agregó esta Carrera para la misma Institución"
              },
              "education_degree": {
                "blank": "Debe seleccionar un Tipo"
              },
              "education_institution": {
                "blank": "Debe seleccionar una Institución"
              },
              "graduated_at": {
                "blank": "Debe una Fecha de Egreso"
              },
              "institution_name": {
                "blank": "Debe agregar una Institución"
              }
            }
          },
          "personal/information": {
            "attributes": {
              "address": {
                "blank": "Debe ingresar su Dirección"
              },
              "birthdate": {
                "blank": "Debe ingresar su Fecha de Nacimiento"
              },
              "cellphone": {
                "blank": "Debe ingresar un Teléfono de Contacto"
              },
              "drivers_license": {
                "blank": "Debe seleccionar su Licencia de Conducir"
              },
              "education_level": {
                "blank": "Debe seleccionar su Nivel Educacional"
              },
              "first_name": {
                "blank": "Debe ingresar su Nombre"
              },
              "gender": {
                "blank": "Debe seleccionar su Género"
              },
              "last_name": {
                "blank": "Debe ingresar su Apellido"
              },
              "nationality": {
                "blank": "Debe seleccionar su Nacionalidad"
              },
              "territory_commune": {
                "blank": "Debe seleccionar País, Región y Comuna"
              }
            }
          },
          "personal/laboral_experience": {
            "attributes": {
              "company_name": {
                "blank": "Debe ingresar el Nombre de la Empresa"
              },
              "company_position": {
                "blank": "Debe ingresar el Nombre del Cargo"
              },
              "laboral_area": {
                "blank": "Debe seleccionar una Área Laboral"
              },
              "recomendation_email": {
                "blank": "Debe agregar un Email"
              },
              "recomendation_name": {
                "blank": "Debe agregar un Nombre"
              },
              "recomendation_phone_number": {
                "blank": "Debe agregar un Teléfono"
              },
              "start_at": {
                "blank": "Debe ingresar un Fecha de Inicio"
              }
            }
          },
          "personal/laboral_requirement": {
            "at_most_five": "no puede tener más de 5 comunas seleccionadas",
            "at_most_ten": "no puede tener más de 10 áreas seleccionadas",
            "attributes": {
              "desired_communes": {
                "at_most_five": "no puede tener más de 5 comunas seleccionadas"
              },
              "laboral_areas": {
                "at_most_ten": "no puede tener más de 10 áreas seleccionadas"
              }
            }
          },
          "postulation/answer": {
            "attributes": {
              "answer": {
                "blank": "Debe ingresar una respuesta"
              }
            }
          },
          "postulation/base": {
            "attributes": {
              "aasm_state": {
                "pending": "La postulación se encuentra pendiente",
                "rejected": "La postulación se encuentra rechazada"
              },
              "applicant": {
                "taken": "Ya postulaste a esta Oferta Laboral"
              },
              "enrollment": {
                "course_closed": "El proceso se encuentra cerrado",
                "current_stage_pending": "Etapa Actual se encuentra pendiente",
                "current_stage_rejected": "Etapa Actual se encuentra rechazada",
                "finished_workflow": "Candidato finalizó el proceso",
                "stage_present": "Candidato ya tiene la etapa de %{stage} asignada"
              }
            }
          },
          "product/base": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar un Nombre"
              },
              "price": {
                "blank": "Debe ingresar un Precio"
              },
              "quantity": {
                "blank": "Debe ingresar una Cantidad"
              }
            }
          },
          "publication/base": {
            "attributes": {
              "address": {
                "blank": "Debe ingresar una Dirección"
              },
              "buk_id": {
                "taken": "Ya existe una publicacion con este ID de Buk"
              },
              "desactivate_at": {
                "blank": "Debe selecionar una Fecha"
              },
              "territory_commune": {
                "blank": "Debe seleccionar una opción"
              }
            }
          },
          "publication/question": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar una Pregunta"
              }
            }
          },
          "stage/base": {
            "attributes": {
              "aasm_state": {
                "blank": "Debe seleccionar una opción"
              }
            }
          },
          "user": {
            "attributes": {
              "avatar": {
                "content_type": "Solo se permite JPG, JPEG, PNG",
                "max_size_error": "No puede superar los 2mb"
              },
              "email": {
                "blank": "Debe ingresar un Email",
                "taken": "Este Email ya se encuentra registrado"
              },
              "identification_document_number": {
                "blank": "Debe ingresar su RUT",
                "invalid": "Debe ingresar un RUT válido"
              },
              "login": {
                "blank": "Debe ingresar un Email o RUT"
              },
              "password": {
                "blank": "Debe indicar una Contraseña"
              },
              "personal_information_attributes": {
                "cellphone": {
                  "blank": "Debe ingresar su celular"
                }
              },
              "terms_and_conditions": {
                "blank": "Debe aceptar los Términos y Condiciones"
              }
            }
          }
        }
      },
      "models": {
        "admin_user": {
          "one": "Usuario administrativo",
          "other": "Usuarios administrativos"
        },
        "company/bussiness_area": {
          "one": "Rubro",
          "other": "Rubros"
        },
        "company/central": {
          "one": "Empresa",
          "other": "Empresas"
        },
        "company/employee": {
          "one": "Empleado",
          "other": "Empleados"
        },
        "course": {
          "one": "Proceso"
        },
        "minisite/postulation": {
          "one": "Postulación Minisitio"
        },
        "personal/contact_information": {
          "one": "Información de Contacto"
        },
        "personal/education": {
          "one": "Estudio",
          "other": "Estudios"
        },
        "personal/information": {
          "one": "Información Personal"
        },
        "personal/laboral_experience": {
          "one": "Experiencia Laboral",
          "other": "Experiencias Laborales"
        },
        "personal/laboral_requirement": {
          "one": "Requerimiento Laboral",
          "other": "Requerimientos Laborales"
        },
        "postulation/answer": {
          "one": "Postulación"
        },
        "postulation/base": {
          "one": "Publicación"
        },
        "publication/base": {
          "one": "Publicación"
        },
        "publication/question": {
          "one": "Publicación"
        },
        "stage/base": {
          "one": "Etapa"
        },
        "trabajando/publication": {
          "one": "Publicación en Trabajando",
          "other": "Publicaciones en Trabajando"
        },
        "user": {
          "one": "Usuario",
          "other": "Usuarios"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "custom": "%d-%m-%Y",
        "default": "%d/%m/%Y",
        "large": "%d de %B de %Y",
        "long": "%A %d de %B de %Y",
        "medium": "%d de %B de %Y",
        "month_year": "%b-%Y",
        "only_year": "%Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de 1 hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de 1 mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de 1 año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi 1 año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de 1 minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de 1 segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de 1 año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "1 día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "1 minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "1 mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "1 segundo",
          "other": "%{count} segundos"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minutos",
        "month": "Mes",
        "second": "Segundos",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Tu cuenta ha sido confirmada satisfactoriamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o contraseña inválidos.",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválidos.",
        "timeout": "Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "¡Hola %{recipient}! ",
          "message": "Estamos contactando contigo para notificarte que tu email ha sido cambiado a %{email}.",
          "subject": "Email cambiado"
        },
        "password_change": {
          "greeting": "Hola %{recipient}!",
          "message": "Le estamos contactando para notificarle que su contraseña ha sido cambiada.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si usted no lo ha solicitado, por favor ignore este correo electrónico.",
          "instruction_3": "Su contraseña no será cambiada hasta que usted acceda al enlace y cree una nueva.",
          "subject": "Instrucciones de recuperación de contraseña"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haga click en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar.",
          "subject": "Instrucciones para desbloquear"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque '%{reason}'.",
        "success": "Has sido autorizado satisfactoriamente en la cuenta %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Nueva contraseña"
        },
        "new": {
          "forgot_your_password": "Olvidé mi contraseña",
          "send_me_reset_password_instructions": "Cambiar mi contraseña"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "Recibirás un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.",
        "updated": "Se ha cambiado tu contraseña. Ya iniciaste sesión.",
        "updated_not_active": "Tu contraseña fue cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada correctamente. Esperamos verte pronto.",
        "edit": {
          "account": "Mis datos",
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Anular mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmacion de: %{email} ",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarlo",
          "title": "Editar %{resource}",
          "unhappy": "Infeliz",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta fue creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta correctamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta se ha actualizado."
      },
      "sessions": {
        "already_signed_out": "Sesión finalizada.",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "sign_out": "Cerrar sesión",
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Atrás",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No ha recibido instrucciones para desbloquear?",
          "forgot_your_password": "Olvidé mi contraseña",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "one": "(%{count} caractere como mínimo)",
          "other": "(%{count} caracteres como mínimo)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear"
        },
        "send_instructions": "Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya ha sido confirmada, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "expired": "ha expirado, por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se ha encontrado",
        "not_locked": "no estaba bloqueada",
        "not_saved": {
          "one": "Ocurrió un error al tratar de guardar:",
          "other": "Ocurrieron %{count} errores al tratar de guardar:"
        },
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "record_invalid": "La validación falló: %{errors}",
        "restrict_dependent_destroy": {
          "many": "No se puede eliminar el registro porque existen %{record} dependientes",
          "one": "No se puede eliminar el registro porque existe un %{record} dependiente"
        },
        "taken": "ya está en uso",
        "too_long": "es demasiado largo (%{count} caracteres máximo)",
        "too_short": "es demasiado corto (%{count} caracteres mínimo)",
        "wrong_length": "no tiene la longitud correcta (%{count} caracteres exactos)"
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró 1 error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "info_dev_mailer": {
      "info": {
        "subject": "Info"
      },
      "postulation_errors": {
        "future_dates_errors": "Hay fechas de postulaciones en el futuro",
        "subject": "Han ocurrido problemas cargando postulaciones de %{company}"
      }
    },
    "messages": {
      "no_info": "No ingresó"
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 0,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": "millón",
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": "billón",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "personal/information": {
      "genders": {
        "female": "Femenino",
        "fluid_gender": "Fluido",
        "male": "Masculino",
        "non_binary": "No Binario",
        "other": "Otro",
        "prefer_not_say": "Prefiero no decirlo"
      }
    },
    "publication/bases": {
      "actions": {
        "activate": {
          "text": "Publicar"
        }
      },
      "errors": {
        "transition": {
          "activate": "La publicación se encuentra creada, pero no se ha podido activar! Comunicate con nosotros.",
          "desactivate": "No es posible desactivar la publicación"
        }
      }
    },
    "pundit": {
      "api_external_policy": {
        "activate?": "No estas autorizado(a) para realizar esta acción",
        "close?": "No estas autorizado(a) para realizar esta acción",
        "contract_types?": "No estas autorizado(a) para realizar esta acción",
        "create?": "No estas autorizado(a) para realizar esta acción",
        "desactivate?": "No estas autorizado(a) para realizar esta acción",
        "education_levels?": "No estas autorizado(a) para realizar esta acción",
        "get_applicants?": "No estas autorizado(a) para realizar esta acción",
        "index?": "No estas autorizado(a) para realizar esta acción",
        "open?": "No estas autorizado(a) para realizar esta acción",
        "preferred_labor_days?": "No estas autorizado(a) para realizar esta acción",
        "preferred_schedules?": "No estas autorizado(a) para realizar esta acción",
        "preferred_turns?": "No estas autorizado(a) para realizar esta acción",
        "update?": "No estas autorizado(a) para realizar esta acción"
      },
      "application_policy": {
        "index?": "No estas autorizado(a) para realizar esta acción"
      },
      "company/central_policy": {
        "index?": "No estás autorizado(a) para ver Empresas"
      },
      "publication/base_policy": {
        "open?": "La publicación se encuentra creada, pero no se ha podido activar. Comunicate con nosotros."
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "custom": "%d/%m/%Y %H:%M",
        "default": "%A, %d de %B de %Y %H:%M:%S %z",
        "large": "%A %d de %B de %Y",
        "long": "%A %d de %B de %Y a las %H:%M",
        "medium": "%d de %B de %Y",
        "month_year": "%b-%Y",
        "only_time": "%H:%M",
        "select": "%d/%m/%Y",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    },
    "trabajando/publication": {
      "actions": {
        "activate": {
          "success": "Aviso re activado exitosamente",
          "text": "Activar aviso",
          "unsuccess": "Aviso no pudo ser re activado"
        },
        "created": {
          "success": "Publicación creada exitosamente"
        },
        "deactivate": {
          "success": "Publicación desactivada exitosamente",
          "text": "Desactivar publicación",
          "unsuccess": "Publicación no pudo ser desactivada"
        },
        "get_trabajando_postulations": {
          "success": "En breve serán actualizadas las postulaciones para este proceso",
          "text": "Actualizar postulaciones"
        }
      },
      "attributes": {
        "trabajando/publication": {
          "applicant_profile_id": "Perfíl de candidato",
          "area_id": "Área",
          "city_id": "Comuna",
          "company_activity_id": "Actividad de la empresa",
          "contract_time": "Plazo del contrato",
          "created_at": "Fecha de Publicación",
          "desactivate_at": "Fecha de desactivación",
          "description": "Descripción",
          "education_level_id": "Estudios mínimos",
          "education_state_id": "Situación de estudios",
          "is_confidential": "Publicación confidencial",
          "job_type_id": "Cargo",
          "minimum_requirements": "Requisitos mínimos",
          "number_vacancies": "Número de vacantes",
          "own_transport": "Transporte propio",
          "postulations": "Postulaciones",
          "q1": "Pregunta 1",
          "q2": "Pregunta 2",
          "q3": "Pregunta 3",
          "q4": "Pregunta 4",
          "q5": "Pregunta 5",
          "region_id": "Región",
          "request_profile_update": "Solicitar actualización de perfil al candidato",
          "salary": "Renta",
          "salary_comment": "Comentario acerca del salario",
          "service": "Trabajando",
          "show_salary": "¿Mostrar renta en el aviso?",
          "software_level_id": "Conocimientos en computación",
          "title": "Título",
          "work_day_id": "Jornada laboral",
          "work_experience": "Años de experiencia",
          "work_time": "Horario de trabajo",
          "workplace": "Lugar de trabajo"
        }
      },
      "errors": {
        "already_exists": "Ya existe una publicación de Trabajando asociada a este curso.",
        "models": {
          "trabajando/publication": {
            "attributes": {
              "applicant_profile": {
                "blank": "Debe indicar un perfíl de candidato"
              },
              "area": {
                "blank": "Debe indicar un área"
              },
              "company_activity": {
                "blank": "Debe indicar la actividad de su empresa"
              },
              "description": {
                "blank": "Debe indicar una descripción"
              },
              "education_level": {
                "blank": "Debe indicar un nivel de estudios mínimos"
              },
              "education_state": {
                "blank": "Debe indicar una situación de estudios"
              },
              "job_type": {
                "blank": "Debe indicar un cargo"
              },
              "salary": {
                "blank": "Debe indicar renta si desea mostrarla"
              },
              "software_level_id": {
                "blank": "Debe indicar conocimientos en computación"
              },
              "title": {
                "blank": "Debe indicar un título"
              },
              "work_day": {
                "blank": "Debe indicar la jornada laboral"
              }
            }
          }
        },
        "transition": "No puede %{action} ya que está %{state}"
      },
      "messages": {
        "delay": "Una vez publicado el proceso podrá ser visualizado en un período aproximado de 40 minutos. En caso de demorar más, reportar a Provisión de Persona.",
        "request_profile_update": "Si selecciona 'Solicitar actualización de perfil al candidato', se le enviará una notificación al postulante para que actualice su perfil."
      },
      "state": {
        "closed": {
          "complete": "Oferta cerrada",
          "default": "cerrada"
        },
        "opened": "abierta"
      }
    }
  }
}